import './QueryModal.css';
import React, { useState } from 'react';

import axios from 'axios';
import ReactQuill from 'react-quill';
import { connect, useSelector } from 'react-redux';
import styled from 'styled-components';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import mailImg from '../../assets/img/mailImg.svg';
import { API_URLS, APPLICATION_HEADERS } from '../../models/headers';

import 'react-quill/dist/quill.snow.css';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const QueryModal = (props) => {
  const data = useSelector((state) => state.optRed.data);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const { surveyData, commonQuery } = props;

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  // console.log(props.option.optionId);
  const showHideClassName = props.show ? 'modal display-block' : 'modal display-none';
  const [query, setQuery] = useState('');
  const [clientEmail, setClientEmail] = useState(props.option.clientEmail);
  const [emailError, setEmailError] = useState();
  const [allProvidersCheck, setAllProvidersCheck] = useState(false);
  // setClientEmail(props.option.clientEmail);

  const validateEmail = (e) => {
    const email = e.target.value;
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(email).toLowerCase());
  };

  const handleEmail = (e) => {
    const valid = validateEmail(e);

    setEmailError(valid);
    setClientEmail(e.target.value);
    if (e.target.value === '') {
      setEmailError(true);
    }
  };
  const updateBubbleSurvey = (url, obj, headers) => {
    axios
      .put(url, obj, { headers })
      .then((res) => {
        if (res && res.status === 200) {
          //successs call
          console.log('success');
          props.option.status = props.requestType;
          props.option.commonqueryData = query;
          props.simplifiedFunction(true, allProvidersCheck);
        } else {
          //    failure call
          console.log('failure');
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          console.log(error);
        } else {
          updateBubbleSurvey(url, obj, headers);
        }
      });
  };
  const updateBubbleOption = (url, obj, headers, queryData) => {
    axios
      .put(url, obj, { headers })
      .then((res) => {
        if (res && res.status === 200) {
          //successs call
          console.log('success');
          props.option.status = props.requestType;
          if (props.requestType == 'TOUR') {
            props.option.isTourDisabled = 'true';
          }
          if (props.requestType == 'PROPOSAL') {
            props.option.isAgreementDisabled = 'true';
          }
          props.simplifiedFunction(true, allProvidersCheck);
          console.log('update sucess');
          if (props.requestType === 'QUERY') {
            props.option.queryData = queryData;
            props.option.allProvidersCheck = allProvidersCheck;
          }
        } else {
          //    failure call
          console.log('failure');
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          console.log(error);
        } else {
          updateBubbleOption(url, obj, headers, queryData);
        }
      });
  };
  const handleSubmit = () => {
    let queryData;

    if (emailError === false) {
      // alert("Text cannot be blank.");
      return;
    }

    handleToggle();

    const reqObj = {
      id: props.option.id,
      status: props.requestType,
    };

    if (props.requestType === 'TOUR') {
      reqObj.isTourDisabled = 'yes';
    }
    if (props.requestType === 'PROPOSAL') {
      reqObj.isAgreementDisabled = 'yes';
    }

    if (props.requestType === 'QUERY') {
      queryData = query;
      if (!allProvidersCheck) {
        const prevQuery = props.option && props.option.queryData;

        if (prevQuery) {
          queryData = prevQuery + ' \r\n' + queryData;
        }
        reqObj.queryData = queryData;
        if (clientEmail) {
          reqObj.clientEmail = clientEmail;
        }

        //if already tour or agreement flow done dont send status to update
        if (props.option.isAgreementDisabled || props.option.isTourDisabled) {
          delete reqObj.status;
        }
      }
    }
    // api if all provider switch in ON

    if (allProvidersCheck) {
      const surveyId = data.id;
      const commonQuestions = data.commonQuestions;

      const prevCommonQuestions = commonQuestions;

      if (props.commonQuery) {
        queryData = props.commonQuery + ' \r\n' + queryData;
      }

      if (prevCommonQuestions) {
        queryData = prevCommonQuestions + ' \r\n' + queryData;
      }

      const optionURL = API_URLS.updateBubbleSurveysURL;

      const commonQuestionObj = {
        id: surveyId,
        commonQuestions: queryData,
      };

      updateBubbleSurvey(optionURL, commonQuestionObj, APPLICATION_HEADERS.dealHeaders);
    } else {
      const optionURL = API_URLS.updateBubbleOptionURL;

      const reqListObj = { list: [reqObj] };

      updateBubbleOption(optionURL, reqListObj, APPLICATION_HEADERS.dealHeaders, queryData);
    }
  };

  return (
    <div>
      {props.requestType == 'TOUR' && (
        <section className="modal-main1" style={{ borderTop: '5px solid #2E5881' }}>
          <div>
            <label className="smsg" style={{ marginTop: '20px' }}>
              Are you sure you want to "Request for Tour" <br /> for the below provider location?
            </label>
            <div style={{ textTransform: 'capitalize' }}>
              <span>{props.option && props.option.provider}</span>
            </div>
            <div style={{ color: 'rgba(33, 33, 33, 0.6)', fontSize: '12px' }}>
              <span></span>
              {props.option.address && props.option.address.address}
            </div>
          </div>

          <div className="modalbtn" style={{ marginTop: '100px' }}>
            <button type="button" className="button secondary" onClick={props.handleClose}>
              Cancel
            </button>
            <button type="button" className="button primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
          <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </section>
      )}

      {props.requestType == 'QUERY' && (
        <section className="modal-main">
          <div>
            <form id="userquery">
              <QuillBlock>
                <ReactQuill
                  theme="snow"
                  id="responseArea"
                  value={query}
                  placeholder="Enter your questions here (required)"
                  preserveWhitespace
                  modules={{
                    clipboard: {
                      matchVisual: false,
                    },
                  }}
                  onChange={(text) => setQuery(text)}
                />
              </QuillBlock>
              <div className="sliderCheck">
                <label className="switch">
                  <input
                    type="checkbox"
                    className="sliderInput"
                    id="filled-in-box"
                    onChange={(e) => setAllProvidersCheck(!allProvidersCheck)}
                  />
                  <span className="slider round"></span>
                </label>
                <span className="staybtn">Ask this question to all the providers</span>
              </div>
              <div className="form-input">
                <img
                  src={mailImg}
                  width="25"
                  style={{ position: 'absolute', margin: '20px 14px' }}
                />
                <div
                  className="user-input-wrp"
                  style={
                    emailError === false && clientEmail !== ''
                      ? { borderBottom: '1px solid red' }
                      : { borderBottom: '1px solid #ccc' }
                  }
                >
                  <TextField
                    className="inputText"
                    id="demo-helper-text-misaligned"
                    label="Enter your email id"
                    onChange={handleEmail}
                    value={clientEmail}
                  />
                  {emailError}
                </div>
              </div>

              <div className="downText">
                We will only use it to send updates for your questions.
              </div>

              <div className="modalbtn">
                <button type="button" className="button secondary" onClick={props.handleClose}>
                  Cancel
                </button>
                <button
                  type="button"
                  className="button primary"
                  onClick={handleSubmit}
                  disabled={query === ''}
                >
                  Submit
                </button>
              </div>
            </form>
            <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        </section>
      )}

      {props.requestType == 'PROPOSAL' && (
        <section className="modal-main1" style={{ borderTop: '5px solid #2E5881' }}>
          <div>
            <label className="smsg" style={{ marginTop: '20px' }}>
              Are you sure you want to "Request for Agreement" <br /> for the below provider
              location?
            </label>
            <div style={{ textTransform: 'capitalize' }}>
              <span>{props.option && props.option.provider}</span>
            </div>
            <div style={{ color: 'rgba(33, 33, 33, 0.6)', fontSize: '12px' }}>
              <span></span>
              {props.option.address && props.option.address.address}
            </div>
          </div>

          <div className="modalbtn" style={{ marginTop: '100px' }}>
            <button type="button" className="button secondary" onClick={props.handleClose}>
              Cancel
            </button>
            <button type="button" className="button primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
          <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </section>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ccmails: state.comRed.ccmails,
    surveyData: state.optRed.data.survey,
    commonQuery: state.comRed.displayCommonQuery,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessElement: (successElement) =>
      dispatch({ type: 'SET_SUCCESS_ELEMENT', successElement }),
  };
};

const QuillBlock = styled.div`
  margin: 20px;

  .quill > .ql-container > .ql-editor.ql-blank::before {
    font-size: 14px;
    color: rgba(26, 26, 26, 0.46);
    font-style: normal;
  }

  .ql-container {
    height: 180px;
    border: none;
    border: 1px solid rgba(26, 26, 26, 0.46);
  }

  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-top: 1px solid rgba(26, 26, 26, 0.46);
  }

  .ql-toolbar .ql-stroke {
    stroke: #003d2f;
  }

  .ql-toolbar .ql-picker {
    color: #003d2f;
  }
`;

export default connect(mapStateToProps, mapDispatchToProps)(QueryModal);

// export default QueryModal;
